import Select, { components } from "react-select";
import React, { memo, useEffect, useMemo, useRef, useState } from "react";
import { orderSummarySelector } from "../../../features/ordersSummary/orderSummarySlice";
import { useSelector } from "react-redux";
import { orderLawyerInfoSelector } from "../../../features/auth/orderLawyerInformationSlice";
import AsyncSelect from "react-select/async";

const CustomSelect = (props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const selectRef = useRef(null);
  const dropdownRef = useRef(null);
  const { programCodeDetails, postOrderDetailsInfo } = useSelector(
    orderLawyerInfoSelector
  );
  const { editOrderDetails } = useSelector(orderSummarySelector);

  // const handleClickOutside = (event) => {
  //   if (selectRef.current && !selectRef.current.contains(event.target)) {
  //     setIsMenuOpen(false);
  //   }
  //   props?.isLenderDropdown && props?.trigger(props?.name);
  //   setFilteredOptions([]); //to make filtered options empty when click outside
  // };
    const handleClickOutside = (event) => {
    if (selectRef.current && !selectRef.current.contains(event.target)) {
      setIsMenuOpen(false);
      if (isMenuOpen && props?.isLenderDropdown) {
        props?.trigger(props?.name);
      }
      
      setFilteredOptions([]); //to make filtered options empty when click outside
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  //donnas fix start
  useEffect(() => {
    if (editOrderDetails && editOrderDetails?.propertyList?.length === 0) {
      if (
        postOrderDetailsInfo &&
        postOrderDetailsInfo?.dealType == "Commercial"
      ) {
        if (
          props?.values?.PropertyUnitNum !== "" &&
          props?.values?.PropertyUnitNum !== null &&
          ["Property_Type"].includes(props?.standardQuestionName)
        ) {
          props?.setValue(props?.name, "1");
          props?.trigger(props?.name);
        } else if (
          props?.values?.PropertyUnitNum === "" &&
          ["Property_Type"]?.includes(props?.standardQuestionName)
        ) {
          props?.setValue(props?.name, "");
        }
      } else if (
        postOrderDetailsInfo &&
        postOrderDetailsInfo?.dealType == "Residential"
      ) {
        if (
          props?.values?.PropertyUnitNum !== "" &&
          props?.values?.PropertyUnitNum !== null &&
          ["PropertyType", "Property_Type"].includes(
            props?.standardQuestionName
          )
        ) {
          props?.setValue(props?.name, "1");
          props?.trigger(props?.name);
        } else if (
          props?.values?.PropertyUnitNum === "" &&
          ["PropertyType", "Property_Type"]?.includes(
            props?.standardQuestionName
          )
        ) {
          props?.setValue(props?.name, "");
        }
      }
    }
  }, [props?.values?.Province, props?.values?.PropertyUnitNum]);

  const DisablePropertyOption = (option, standardQuestionName, values) => {
    let val = "";
    if (
      postOrderDetailsInfo &&
      postOrderDetailsInfo?.dealType == "Commercial"
    ) {
      if (
        values?.Province !== "QC" &&
        //programCodeDetails === null &&
        values?.PropertyUnitNum !== "" &&
        values?.PropertyUnitNum !== null &&
        ["Property_Type"]?.includes(standardQuestionName) &&
        !["1", "8"]?.includes(option?.value)
      ) {
        val = option?.value;
      }
    } else if (
      postOrderDetailsInfo &&
      postOrderDetailsInfo?.dealType == "Residential"
    ) {
      if (
        values?.Province !== "QC" &&
        //programCodeDetails === null &&
        values?.PropertyUnitNum !== "" &&
        values?.PropertyUnitNum !== null &&
        ["PropertyType", "Property_Type"]?.includes(standardQuestionName) &&
        !["1", "13", "9", "11"]?.includes(option?.value)
      ) {
        val = option?.value;
      }
    }

    return val;
  };
  //donnas fix end

  const [isNoOption, setIsNoOption] = useState(false);
  const colourStyles = {
    indicatorsContainer: (styles) => ({
      ...styles,
      maxHeight: 30,
      display: props?.tinySelect ? "none" : "flex",
      alignItems: "center",
      justifyContent: "center",
    }),
    input: (styles, data) => ({
      ...styles,
      border: "none !important",
      boxSizing: "none !important",
      backgroundColor: "white !important",
      display: "contents",
      minWidth: 0,
      marginTop: -10,
      "&:after": {
        ...styles["&:after"],
        minWidth: 0,
        border: "none !important",
        whiteSpace: "normal",
        display: "hidden",
        marginTop: -25,
        padding: 0,
      },
      "&:focus": {
        border: "none !important",
        outline: "none !important",
      },
      "&:hover": {
        backgroundColor: "white !important",
        border: "none !important",
        outline: "none !important",
      },
    }),
    control: (styles) => ({
      ...styles,
      width: props?.tinySelect ? 40 : "100%",
      cursor: "pointer",
      minHeight: props?.tinySelect ? 30 : "40px",
      maxHeight: props?.tinySelect ? 30 : "auto",
      color: "#595959",
      background: "#fff",
      border: "1px solid #a09f9f",
      borderRadius: "2px",
      justifyContent: "space-between",
      outline: "0.5px solid white !important",
      "&:hover": {
        color: "#595959 !important",
        boxShadow: "none !important",
        backgroundColor: "#fafafa !important",
        border: "1px solid #595959 !important",
        outline: "none !important",
      },
      "&:focus": {
        backgroundColor: "none",
        outline: "1px solid #595959 !important",
      },
    }),
    singleValue: (styles, { data }) => ({
      ...styles,
      color: data?.value === "0" ? "gray" : styles.color,
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => ({
      ...styles,
      "&:hover": {
        backgroundColor: isDisabled ? "#f0f0f0" : "#fffaeb",
        fontWeight: "600",
        boxShadow: "none !important",
        outline: "1px solid #595959 !important",
      },
      "&:focus": {
        backgroundColor: isDisabled ? "#f0f0f0" : "#fffaeb",
        fontWeight: "600",
        boxShadow: "none !important",
        outline: "1px solid #595959 !important",
      },
      color: isDisabled ? "#ccc" : "#231f20",
      cursor: isDisabled ? "not-allowed" : "pointer",
      height: "auto !important",
      marginTop: "-2px",
      marginBottom: "-2.5px",
      backgroundColor: isDisabled
        ? "#f0f0f0"
        : isFocused
          ? "#fffaeb"
          : "transparent",
      // // top: '98% !important',
      // // transform: 'translate3d(0, 0, 0) !important'
    }),
    menu: (base) => ({
      ...base,
      marginTop: "1px",
      minWidth: "100%",
      minHeight: "100%",
      outline: "1px solid #595959 !important",
      borderRadius: "0px",
      display: isNoOption ? "flex" : "",
      flexDirection: isNoOption ? "column-reverse" : "", // Reverse the order of menu items
    }),
    noOptionsMessage: (provided) => ({
      ...provided,
      order: -1, // This will place the message at the top
      textAlign: "left", // Align the text to the left
      paddingLeft: "10px", // Add some padding to the left if needed
    }),
  };

  const defaultOption =
    props?.defaultValue !== undefined
      ? { label: props?.defaultValue, value: "0" }
      : "";

  const newOptions =
    props?.options && props?.defaultValue !== undefined
      ? [
        { label: props?.defaultValue, value: "0", disabled: true },
        ...props?.options,
      ]
      : props?.options;

  const [filteredOptions, setFilteredOptions] = useState([]);

  const handleKeyDown = (e) => {
    if (newOptions !== undefined) {
      setFilteredOptions(
        newOptions?.filter((x) =>
          x.label.toString()?.toLowerCase().startsWith(e.key)
        )
      );
      document.addEventListener("keydown", handleKeyDown);
    }
  };

  const setNoOption = (props) => {
    setIsNoOption(true);
    return props?.t("NoOptionFound");
  };
  const CustomMenuButtonControl = (propsChild) => {
    return (
      <components.Menu {...propsChild}>
        <div className="w-full">
          <button
            onClick={() => props?.customMenuButtonAction()}
            className="btn_icon_lender"
          >
            <svg
              width="20"
              aria-hidden="true"
              height="21"
              viewBox="4 2 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <line
                x1="4"
                y1="10.6816"
                x2="16"
                y2="10.6816"
                stroke="#231F20"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <line
                x1="10"
                y1="4.5"
                x2="10"
                y2="16.5"
                stroke="#231F20"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
            {props?.t("AddNewLender")}
          </button>
        </div>
        {propsChild?.children}
      </components.Menu>
    );
  };

  const focusNextElement = () => {//when we use tab after selection from dropdown it takes two tabs to focus next element, so this code i added to manually focus to next element after the selection from dropdown
    const focusable = 'button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])';
    const elements = Array.from(document.querySelectorAll(focusable)).filter(x =>
      (x.hasAttribute("disabled") ? x.classList.contains("btn__icon-file") : true) &&//not taking diabled attribute except 'btn__icon-file' class
      x.tabIndex >= 0 &&
      x.offsetParent !== null
    );

    const active = document?.activeElement;
    const selectWrapper = active?.closest(".react-select-wrapper");

    let index = elements?.indexOf(active);
    while (
      index + 1 < elements?.length &&
      selectWrapper &&
      selectWrapper?.contains(elements[index + 1])
    ) {
      index++;
    }

    if (index > -1 && index + 1 < elements?.length) {
      const nextElement = elements[index + 1];

      // Try to find associated label
      let label = null;

      // Case 1: Label using `for` attribute
      if (nextElement?.name) {
        label = document?.querySelector(`label[for="${nextElement.name}"]`);
      }

      // Case 2: Label is a parent or sibling
      if (!label) {
        label = nextElement?.closest("label") || nextElement?.parentElement?.querySelector("label");
      }

      // Focus the label if found
      if (label) {
        label?.scrollIntoView({ behavior: "smooth", block: "center" });

        if (!label?.hasAttribute("tabindex")) {
          label?.setAttribute("tabindex", "-1");
        }

        // Apply inline styles to suppress background
        label.style.outline = "none";
        label.style.backgroundColor = "transparent";

        label?.focus?.({ preventScroll: true });
      } else {
        nextElement?.focus({ preventScroll: true });
      }
    }
  };


  return !props?.isAsync ? (
    <div id={props?.name} tabIndex="-1" ref={selectRef} className="react-select-wrapper">
      <Select
        name={props?.name}
        defaultValue={defaultOption}
        //   className='Mandatory'
        styles={colourStyles}
        menuPortalTarget={document.body}
        //   required={true}
        key={props?.key}
        data-cy={props?.testId}
        options={
          filteredOptions && filteredOptions?.length > 0
            ? filteredOptions?.filter((item) => item?.value != 0)
            : newOptions?.filter((item) => item?.value != 0)
        }
        onChange={(e) => {
          if (!props?.isMultiSelect)
            props?.onChange(
              e.value,
              props?.name,
              props?.standardQuestionName,
              e
            );
          else
            props?.multiSelectOnChange(
              e,
              props?.name,
              props?.standardQuestionName
            );
          setTimeout(() => {
            if (!props?.isMultiSelect)
              props?.onChange(
                e.value,
                props?.name,
                props?.standardQuestionName,
                e
              );
            else
              props?.multiSelectOnChange(
                e,
                props?.name,
                props?.standardQuestionName
              );
          }, 0); //this is kind of hotfix , need to revisit
          setFilteredOptions([]);
        }}
        // onBlur={(e) => {//commented since when dropdown change ,onblur also getting trigegred
        //   // e.preventDefault();
        //   if (
        //     (props?.currentValue && props?.currentValue !== "0") ||
        //     e.target.value
        //   )
        //     props?.onChange(
        //       props?.currentValue || e.target.value,
        //       props?.name,
        //       props?.standardQuestionName,
        //       e
        //     );
        //   // props?.onChange(props?.currentValue, e.name);
        //   setIsNoOption(false);
        // }}
        inputRef={props?.inputRef}
        value={
          props?.currentValue
            ? props?.isMultiSelect
              ? newOptions?.filter(
                (c) =>
                  props?.currentValue instanceof Array &&
                  props?.currentValue?.some((x) => x?.value === c?.value)
              )
              : newOptions?.find((c) => c?.value === props?.currentValue)
            : !props?.value
              ? defaultOption
              : props?.isMultiSelect && props?.value instanceof Array
                ? newOptions?.filter((c) =>
                  props?.value?.some((x) => x?.value === c?.value)
                )
                : newOptions?.find((c) => c.value === props?.value)
        }
        blurInputOnSelect={true}
        isDisabled={props?.isDisabled}
        isSearchable={props?.isSearchable === false ? false : true}
        placeholder={props?.placeholder || "Select"}
        components={{
          Input: (props) => <CustomInput {...props} />,
          Option: (propss) => (
            <CustomOption
              {...propss}
              isOptionEditable={props?.isOptionEditable}
              customOptionEditAction={props?.customOptionEditAction}
              props={props}
            />
          ),
          SelectContainer: (props) => <CustomSelectContainer {...props} />,
          IndicatorSeparator: () => null,
          ...(props?.isCustomMenuButton && { Menu: CustomMenuButtonControl }),
          DropdownIndicator: (props1) =>
            props?.isMultiSelect ? null : (
              <components.DropdownIndicator {...props1} />
            ),
          ...(props?.isLimitSearchResult && {
            MenuList: (props2) => {
              const searchTerm = props2?.selectProps?.inputValue;
              const children = React?.Children?.toArray(props2?.children);
              return (
                <components.MenuList {...props2}>
                  {searchTerm?.trim() === "" ? children : children?.slice(0, props?.isLimitSearchResult)}
                </components.MenuList>
              );

            }
          })
        }}
        isMulti={props?.isMultiSelect}
        standardQuestionName={props?.standardQuestionName}
        // onKeyDown={!props?.isSearchable ? handleKeyDown : ""}
        onMenuOpen={(e) => {
          setIsMenuOpen(true);
          if (props?.handleMenuOpen != undefined) {
            props?.handleMenuOpen(
              props?.currentValue || e,
              props?.name,
              newOptions?.find((c) => c?.value === props?.currentValue)?.label
            );
          }
        }}
        onMenuClose={() => { setIsMenuOpen(false); focusNextElement(); }}
        menuIsOpen={isMenuOpen}
        // isOptionDisabled={(option) =>
        //   option?.value ===
        //   DisablePropertyOption(
        //     option,
        //     props?.standardQuestionName,
        //     props?.values
        //   )
        // }
        menuPortalTarget={props.tinySelect && document.body}
        noOptionsMessage={() => props?.isLenderDropdown && setNoOption(props)}
        onInputChange={props?.handleInputChange}
        isLoading={props?.isLoading}
      />
    </div>
  ) : (
    <div id={props?.name} tabIndex="-1" ref={selectRef} className="react-select-wrapper">
      <AsyncSelect
        cacheOptions
        name={props?.name}
        defaultValue={defaultOption}
        //   className='Mandatory'
        debounceTimeout={3000}
        styles={colourStyles}
        //   required={true}
        key={props?.key}
        data-cy={props?.testId}
        defaultOptions={
          filteredOptions && filteredOptions?.length > 0
            ? filteredOptions?.filter((item) => item?.value != 0)
            : newOptions?.filter((item) => item?.value != 0)
        }
        loadOptions={props?.loadOptions}
        onChange={(e) => {
          if (!props?.isMultiSelect)
            props?.onChange(
              e.value,
              props?.name,
              props?.standardQuestionName,
              e
            );
          else
            props?.multiSelectOnChange(
              e,
              props?.name,
              props?.standardQuestionName
            );
          setTimeout(() => {
            if (!props?.isMultiSelect)
              props?.onChange(
                e.value,
                props?.name,
                props?.standardQuestionName,
                e
              );
            else
              props?.multiSelectOnChange(
                e,
                props?.name,
                props?.standardQuestionName
              );
          }, 0); //this is kind of hotfix , need to revisit
          setFilteredOptions([]);
        }}
        onBlur={(e) => {
          // e.preventDefault();
          if (
            (props?.currentValue && props?.currentValue !== "0") ||
            e.target.value
          )
            props?.onChange(
              props?.currentValue || e.target.value,
              props?.name,
              props?.standardQuestionName,
              e
            );
          // props?.onChange(props?.currentValue, e.name);
          setIsNoOption(false);
        }}
        inputRef={props?.inputRef}
        value={
          props?.currentValue
            ? props?.isMultiSelect
              ? newOptions?.filter(
                (c) =>
                  props?.currentValue instanceof Array &&
                  props?.currentValue?.some((x) => x?.value === c?.value)
              )
              : newOptions?.find((c) => c?.value === props?.currentValue)
            : !props?.value
              ? defaultOption
              : props?.isMultiSelect && props?.value instanceof Array
                ? newOptions?.filter((c) =>
                  props?.value?.some((x) => x?.value === c?.value)
                )
                : newOptions?.find((c) => c.value === props?.value)
        }
        blurInputOnSelect={true}
        isDisabled={props?.isDisabled}
        isSearchable={true}
        placeholder={props?.placeholder || "Select"}
        components={{
          Input: (props) => <CustomInput {...props} />,
          Option: (propss) => (
            <CustomOption
              {...propss}
              isOptionEditable={props?.isOptionEditable}
              customOptionEditAction={props?.customOptionEditAction}
              props={props}
            />
          ),
          SelectContainer: (props) => <CustomSelectContainer {...props} />,
          IndicatorSeparator: () => null,
          ...(props?.isCustomMenuButton && { Menu: CustomMenuButtonControl }),
          DropdownIndicator: (props1) =>
            props?.isMultiSelect ? null : (
              <components.DropdownIndicator {...props1} />
            ),
        }}
        isMulti={props?.isMultiSelect}
        standardQuestionName={props?.standardQuestionName}
        // onKeyDown={!props?.isSearchable ? handleKeyDown : ""}
        onMenuOpen={(e) => {
          setIsMenuOpen(true);
          if (props?.handleMenuOpen != undefined) {
            props?.handleMenuOpen(
              props?.currentValue || e,
              props?.name,
              newOptions?.find((c) => c?.value === props?.currentValue)?.label
            );
          }
        }}
        onMenuClose={() => { setIsMenuOpen(false); }}
        menuIsOpen={isMenuOpen}
        // isOptionDisabled={(option) =>//US777659, second point( should not disable the option when unit is entered)
        //   option?.value ===
        //   DisablePropertyOption(
        //     option,
        //     props?.standardQuestionName,
        //     props?.values
        //   )
        // }
        menuPortalTarget={props.tinySelect && document.body}
        noOptionsMessage={() => {
          //setIsNoOption(true);
          return props?.t("NoOptionFound");
        }}
        onInputChange={props?.handleInputChange}
        isLoading={props?.isLoading}
      />
    </div>
  );
};

const CustomInput = (props) => (
  <span
    className="customInput_search_style"
    data-cy={`${props?.selectProps["data-cy"]}-value`}
  >
    <components.Input {...props} />
  </span>
);

const CustomOption = (props) => (
  <span
    data-cy={`${props?.selectProps["data-cy"]}-option-${props?.data?.id || props?.data?.value
      }`}
    key={props?.innerprops?.key}
  >
    <components.Option {...props}>
      {props?.data?.label}
      {props?.isOptionEditable &&
        props?.data?.value !== 0 &&
        props?.data?.value !== "0" && (
          <>
            <EditButton
              onClick={(e) => {
                e?.stopPropagation();
                e?.preventDefault();
                props?.customOptionEditAction(props?.data?.value)
              }}
              props={props?.props}
            />
          </>
        )}
    </components.Option>
  </span>
);

const CustomSelectContainer = (props) => (
  <span data-cy={`${props?.selectProps["data-cy"]}`}>
    <components.SelectContainer {...props} />
  </span>
);

const EditButton = ({ onClick, props }) => (
  <button onClick={onClick} style={{ float: "right", color: "#738895" }}>
    {props?.t('Edit')}
  </button>
);
export default memo(CustomSelect);
